import styled from 'styled-components'

import Checkbox from 'shared/ui/Checkbox'
import Flex from 'shared/ui/Flex'

export const Container = styled(Flex).attrs({
  columnGap: 8
})<{ $marked?: boolean; $hasCheckbox?: boolean }>`
  position: relative;
  padding: 16px;
  padding-right: ${({ $hasCheckbox }) =>
    $hasCheckbox ? 40 : 16}px;
  border-radius: 10px;
  border: 2px solid
    ${({ $marked, theme }) =>
      $marked ? theme.color.brand_02 : theme.color.base.c3};
  box-shadow: -2px 2px 1px rgba(203, 213, 225, 0.2);
  cursor: pointer;
  opacity: ${({ $marked }) => ($marked ? 0.5 : 1)};
  transition:
    border-color 0.15s ease-in-out,
    opacity 0.15s ease-in-out;
`

const CheckboxWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
`

const Title = styled.span`
  color: ${({ theme }) => theme.color.base.c7};
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
`

type CollageItemProps = {
  title: string
  onClick: () => void
  isMarked?: boolean
  onToggleMark?: () => void
}

const ReportItem: React.FC<CollageItemProps> = ({
  title,
  isMarked,
  onToggleMark,
  ...rest
}) => {
  const hasCheckbox = !!onToggleMark

  return (
    <Container
      {...rest}
      $marked={isMarked}
      $hasCheckbox={hasCheckbox}
    >
      {hasCheckbox && (
        <CheckboxWrapper onClick={e => e.stopPropagation()}>
          <Checkbox
            checked={!!isMarked}
            onChange={() => onToggleMark?.()}
          />
        </CheckboxWrapper>
      )}
      <Title>{title}</Title>
    </Container>
  )
}
export default ReportItem
